import {
  makeStyles,
  createStyles,
  Theme
} from "@material-ui/core/styles";
import { useStyles as useStylesLogin, BootstrapInput } from './../../../../assets/styles/stylesLogin'

const useStyles: any = makeStyles((theme: Theme) =>
  createStyles({
    ...useStylesLogin(theme)
  })
);

export { useStyles, BootstrapInput }
